import { TextField } from "@material-ui/core";
import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux";
import { addDataToWatchlist, removeDataFromWatchlist } from "../../redux/action/userActions";
import { getSuggestions, fetchMarketDataWithArray } from "../../redux/action/marketActions";
import { getLocalStorage } from "../../utils/localStorage";
import { Buy } from "../Windows/Buy";
import { SearchSuggestions } from "../Windows/SearchSuggestions";
import { Sell } from "../Windows/Sell";
import { WatchList } from "./WatchList";
import {  useSnackbar } from 'notistack';
import { orderreset } from "../../redux/action/orderActions";
import { GainersList } from './Gainers';
import { LosersList } from './Losers';
export const MarketWatch = () => {

  const { enqueueSnackbar } = useSnackbar();
  const [user, setUser] = useState(getLocalStorage("user"))
  const [watchListData, setWatchListData] = useState([])
  const [instrumentForOrder, setInstrumentForOrder] = useState()
  const [open, setOpen] = useState(false);
  const [searchItem, setSearchItem] = useState("");
  const [suggestions, setSuggestions] = useState([])
  const dispatch = useDispatch();
  const {  status, failedMessage } = useSelector(state => ({
    status: state.orderState.status,
    failedMessage: state.orderState.failedMessage
  }))
  useEffect($=>{
    status==="completed" &&   enqueueSnackbar('Order completed successfully', { variant : 'success' });
    status==="failed" &&  enqueueSnackbar( failedMessage, { variant : 'error' })
    return () => dispatch(orderreset());
 }, [status, dispatch, enqueueSnackbar, failedMessage])

  useEffect($ => {
    user.watchlist.length !== 0 &&
      dispatch(fetchMarketDataWithArray(
        [...new Set(user.watchlist)],
        setWatchListData)
      )
  }, [user, dispatch]);
  
  const addToWatchlist = instrument => {
    setSuggestions([]);
    setSearchItem("");
    const payload = { instrument, 
      user
    }
    dispatch(addDataToWatchlist(payload, setUser))
    enqueueSnackbar('Added successfully', { variant : 'success' });

  }
  const removeFromWatchlist = instrument => {
    const payload = { instrument, 
      user
    }
    dispatch(removeDataFromWatchlist(payload, setUser))
    enqueueSnackbar('Removed successfully', { variant : 'info' });
  }
  const fetchSearch = $ => {
    setTimeout(() =>
      dispatch(getSuggestions(searchItem, setSuggestions))
      , 500)
  }
  
  return <>

    <TextField value={searchItem} onChange={e => setSearchItem(e.target.value)} onKeyUp={fetchSearch} id="search" halfwidth="true" label="Search Instruments" variant="standard" />
    {suggestions?.length > 0 && <SearchSuggestions
      addToWatchlist={addToWatchlist}
      data={suggestions} />}
    <WatchList watchListData={watchListData} setInstrumentForOrder={setInstrumentForOrder}
                  setOpen={setOpen} removeFromWatchlist={removeFromWatchlist}/>
      <br/> <h1>Top Gainers</h1>          
                  <GainersList setInstrumentForOrder={setInstrumentForOrder}
                  setOpen={setOpen} />
        
          
           <br/>
           <h1>Top Losers</h1>
                  <LosersList setInstrumentForOrder={setInstrumentForOrder}
                  setOpen={setOpen} />
       
  
    {open === "buy" && <Buy setOpen={setOpen} user={user} instrument={instrumentForOrder} />}
    {open === "sell" && <Sell setOpen={setOpen} user={user} instrument={instrumentForOrder} />}
    
  </>
}



